import { readSiteSettingsFromStorage } from './siteBranding';
import {
  normalizeContactChannelsData,
  normalizeWhatsappDigits,
  parseContactChannelsFromStorage,
} from './whatsappContact';

/** Shown when API / admin has not set site phone yet */
export const DEFAULT_DISPLAY_PHONE = '+92 326 1211117';

export const DEFAULT_CONTACT_EMAIL = 'superwearhouse@gmail.com';

/**
 * Format E.164-ish digits for display (Pakistan): +92 3XX XXXXXXX
 * @param {string} digits — digits only, with country code
 */
export function formatPkMobileForDisplay(digits) {
  const d = normalizeWhatsappDigits(digits);
  if (!d) return '';
  if (d.startsWith('92') && d.length >= 12) {
    const rest = d.slice(2);
    return `+92 ${rest.slice(0, 3)} ${rest.slice(3)}`.trim();
  }
  if (d.length >= 10) return `+${d}`;
  return d;
}

/**
 * Public storefront phone line:
 * 1) `sitePhone` from GET /settings/public → localStorage (admin **Settings** site phone)
 * 2) WhatsApp chat / order digits from contact channels (same as floating chat)
 * 3) default placeholder
 */
export function getPublicSitePhoneDisplay() {
  try {
    const s = readSiteSettingsFromStorage();
    const sitePhone = typeof s?.sitePhone === 'string' ? s.sitePhone.trim() : '';
    if (sitePhone) return sitePhone;
  } catch {
    /* ignore */
  }
  const ch = normalizeContactChannelsData(parseContactChannelsFromStorage() || {});
  const raw = ch.whatsappChatNumber || ch.whatsappOrderNumber || '';
  const formatted = formatPkMobileForDisplay(raw);
  if (formatted) return formatted;
  return DEFAULT_DISPLAY_PHONE;
}

export function getPublicSiteEmail() {
  try {
    const s = readSiteSettingsFromStorage();
    const e = typeof s?.siteEmail === 'string' ? s.siteEmail.trim() : '';
    if (e) return e;
  } catch {
    /* ignore */
  }
  return DEFAULT_CONTACT_EMAIL;
}

/** Social profile URLs from contact settings (local cache of GET /settings/contact). */
export function getPublicSocialLinks() {
  const ch = normalizeContactChannelsData(parseContactChannelsFromStorage() || {});
  return {
    twitterUrl: ch.twitterUrl || '',
    facebookUrl: ch.facebookUrl || '',
    instagramUrl: ch.instagramUrl || '',
    tiktokUrl: ch.tiktokUrl || '',
  };
}

/** `tel:` href — digits only */
export function getTelHrefFromDisplayPhone(displayPhone) {
  const d = normalizeWhatsappDigits(displayPhone);
  return d ? `tel:+${d}` : `tel:${String(displayPhone || '').replace(/\s/g, '')}`;
}
